import React from 'react';
import { Button } from '../shared/Button';
import type { TimerState } from '../../types';

interface TimerControlsProps {
  state: TimerState;
  onStart: () => void;
  onPause: () => void;
  onStop: () => void;
  onReset: () => void;
}

export function TimerControls({ state, onStart, onPause, onStop, onReset }: TimerControlsProps) {
  return (
    <div className="flex items-center justify-center gap-2 flex-wrap">
      {state === 'idle' && (
        <Button variant="primary" size="sm" onClick={onStart}>
          ▶ Démarrer
        </Button>
      )}

      {state === 'running' && (
        <>
          <Button variant="secondary" size="sm" onClick={onPause}>
            ⏸ Pause
          </Button>
          <Button variant="danger" size="sm" onClick={onStop}>
            ⏹ Stop
          </Button>
        </>
      )}

      {state === 'paused' && (
        <>
          <Button variant="primary" size="sm" onClick={onStart}>
            ▶ Reprendre
          </Button>
          <Button variant="danger" size="sm" onClick={onStop}>
            ⏹ Stop
          </Button>
          <Button variant="ghost" size="sm" onClick={onReset}>
            ↺ Reset
          </Button>
        </>
      )}

      {state === 'finished' && (
        <Button variant="ghost" size="sm" onClick={onReset}>
          ↺ Réinitialiser
        </Button>
      )}
    </div>
  );
}
